import { i18n } from 'config/locales';

// Legal / Investigations / History / Police Record
export const US_DEPT_OF_TREASURY = 'U.S. Department of Treasury';
export const FOREIGN_GOVT = 'Foreign government';
export const OTHER = 'Other';

export const offenseChargeTypes = ['Felony', 'Misdemeanor', 'Other'];

// PVQ Dropdown values
export const criminalOutcomeOptions = [
  'Not guilty',
  'Nolle Prosequi',
  'Charge dismissed or disposed of',
  'Charge dismissed or disposed of after a deferred adjudication or deferred judgment (not applicable for military under the UCMJ)',
  'Guilty',
  'On trial',
  'Awaiting trial',
  'Other',
];

// PVQ Dropdown values
export const criminalSentenceOptions = [
  'Fined',
  'Community Service',
  'Imprisonment',
  'Probation',
  'Counseling/Treatment/Training',
  'Other',
];

// PVQ Dropdown values
export const chargeTypes = [
  'Infraction or Violation',
  'Summary offense',
  'Misdemeanor offense',
  'Felony offense',
  'Other',
];

// PVQ Dropdown values
export const domesticOrderOptions = [
  'Spouse',
  'Former spouse',
  'Co-habitant',
  'Former cohabitant',
  'Person you were dating',
  'Former person you were dating',
  'Domestic partner',
  'Former domestic partner',
  'Parent',
  'Child',
  'Sibling',
  'Grandparent',
  'In-law',
  'Other',
];

// PVQ Dropdown values
export const lawEnforcementPositionTypes = [
  'Police/law enforcement officer',
  'Parole/probation officer',
  '911 dispatcher',
  'Correction officer',
  'Lawyer',
  'Court official',
  'Firefighter',
  'EMS',
  'Medical and health services member',
  'Emergency response team member',
  'Other',
];

// PVQ Court Part Status
export const courtPartyStatus = {
  plaintiff: 'Plaintiff',
  defendant: 'Defendant',
};
// PVQ Dropdown values
export const civilCourtOutcomeOptions = [
  'I was awarded damages',
  'I was awarded restitution',
  'I was awarded other remedies',
  'I had to pay damages',
  'I had to make restitution',
  'I had to do other remedies',
  'Other',
];

// PVQ Dropdown values
export const criminalOutcomeSentenceOverOneYearOptions = [
  'Not guilty',
  'Nolle Prosequi',
  'Charge dismissed or disposed of',
  'Guilty',
  'Other',
];

export const getAgencyPVQOptions = () => {
  const prefix = 'legal.pvq.investigations.history.label.agency';
  return [
    { label: ' ', value: ' ' },
    { label: i18n.t(`${prefix}.cia`), value: 'Central Intelligence Agency (CIA)' },
    { label: i18n.t(`${prefix}.afosi`), value: 'DoD - Air Force Office of Special Investigations (AFOSI)' },
    { label: i18n.t(`${prefix}.dcsa`), value: 'DoD - Defense Counterintelligence and Security Agency (DCSA)' },
    { label: i18n.t(`${prefix}.dia`), value: 'DoD - Defense Intelligence Agency (DIA)' },
    { label: i18n.t(`${prefix}.nga`), value: 'DoD - National Geospatial-Intelligence Agency (NGA)' },
    { label: i18n.t(`${prefix}.nro`), value: 'DoD - National Reconnaissance Office (NRO)' },
    { label: i18n.t(`${prefix}.nsa`), value: 'DoD - National Security Agency (NSA)' },
    { label: i18n.t(`${prefix}.cbp`), value: 'DHS - Customs and Border Protection (CBP)' },
    { label: i18n.t(`${prefix}.fema`), value: 'DHS - Federal Emergency Management Agency (FEMA)' },
    { label: i18n.t(`${prefix}.dhshq`), value: 'DHS - Headquarters (DHS-HQ)' },
    { label: i18n.t(`${prefix}.ice`), value: 'DHS - Immigration and Customs Enforcement (ICE)' },
    { label: i18n.t(`${prefix}.tsa`), value: 'DHS - Transportation Security Agency (TSA)' },
    { label: i18n.t(`${prefix}.uscg`), value: 'DHS - U.S. Coast Guard (USCG)' },
    { label: i18n.t(`${prefix}.uscis`), value: 'DHS - U.S. Customs and Immigration Service (USCIS)' },
    { label: i18n.t(`${prefix}.usss`), value: 'DHS - U.S. Secret Service (USSS)' },
    { label: i18n.t(`${prefix}.atf`), value: 'DOJ - Bureau of Alcohol, Tobacco, Firearms and Explosives (ATF)' },
    { label: i18n.t(`${prefix}.fbi`), value: 'DOJ - Federal Bureau of Investigation (FBI)' },
    { label: i18n.t(`${prefix}.dos`), value: 'U.S. Department of State (DoS)' },
    { label: i18n.t(`${prefix}.tbep`), value: 'Treasury - Bureau of Engraving and Printing' },
    { label: i18n.t(`${prefix}.tbfs`), value: 'Treasury - Bureau of Fiscal Services' },
    { label: i18n.t(`${prefix}.mcc`), value: 'Millennium Challenge Corporation' },
    { label: i18n.t(`${prefix}.opm`), value: 'Office of Personnel Management (OPM)' },
    { label: i18n.t(`${prefix}.tva`), value: 'Tennessee Valley Authority (TVA)' },
    { label: i18n.t(`${prefix}.usaid`), value: 'U.S. Agency for International Development (USAID)' },
    { label: i18n.t(`${prefix}.uspc`), value: 'U.S. Peace Corps (USPC)' },
    { label: i18n.t(`${prefix}.uspis`), value: 'U.S. Postal Inspection Service (USPIS)' },
    { label: i18n.t(`${prefix}.other`), value: 'Other' },
    { label: i18n.t(`${prefix}.idk`), value: `I don't know` },
  ];
};
